<template>
    <ActionModalTemplate
        :show="show"
        :actionTitle="actionTitle || $lang.get('Delete')"
        :actionBody="
            actionBody ||
            $lang.get(
                'Are you sure you want to delete :definitive_item_name?',
                { definitive_item_name: null }
            )
        "
        :cancelText="cancelText || $lang.get('Cancel')"
        iconBgColor="bg-danger/20"
        @close="close"
    >
        <template #icon>
            <PhWarning class="h-6 w-6 text-danger" aria-hidden="true" />
        </template>
        <template #confirmButton>
            <DangerButton
                @click="confirmed"
                v-text="confirmText || $lang.get('Delete')"
                size="sm"
                class="font-header"
            />
        </template>
    </ActionModalTemplate>
</template>

<script>
import ActionModalTemplate from '@/Components/Templates/ActionModalTemplate.vue'
import DangerButton from '@/Components/Elements/DangerButton.vue'
import { PhWarning } from '@phosphor-icons/vue'

export default {
    name: 'ConfirmDangerModal',

    components: {
        ActionModalTemplate,
        DangerButton,
        PhWarning,
    },

    expose: ['confirm'],

    data() {
        return {
            show: false,
            actionTitle: null,
            actionBody: null,
            cancelText: null,
            confirmText: null,
            resolveCallback: null,
        }
    },

    methods: {
        confirm({ title, body, confirmText = null, cancelText = null }) {
            this.actionTitle = title
            this.actionBody = body
            this.confirmText = confirmText
            this.cancelText = cancelText

            this.show = true
            return new Promise((resolve) => {
                this.resolveCallback = resolve
            })
        },

        confirmed() {
            this.show = false
            this.resolveCallback(true)
        },

        close() {
            this.show = false
            this.resolveCallback(false)
        },
    },
}
</script>
